import type { RouteRecordRaw } from 'vue-router';

export const productCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/product/category',
    name: 'productCategory',
    redirect: '/product/category/list',
    component: () => import('pages/trade/admin/productCategory/ProductCategory.vue'),
    meta: {
      title: 'Product Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:groupId?/:appId?',
        name: 'productCategoryList',
        component: () => import('pages/trade/admin/productCategory/ProductCategoryList.vue'),
        meta: {
          title: 'Product Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:groupId?/:appId?',
        name: 'productCategoryDetail',
        component: () => import('pages/trade/admin/productCategory/ProductCategoryDetail.vue'),
        meta: {
          title: 'Product Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/productId?/:groupId?/:appId?',
        name: 'productCategoryNew',
        component: () => import('pages/trade/admin/productCategory/ProductCategoryNew.vue'),
        meta: {
          title: 'New Product Category',
          requiresAuth: true,
        },
      },
    ],
  },
];
